import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "shadow-top relative z-10 flex flex-shrink-0 bg-white" }
const _hoisted_2 = { class: "w-full px-3 py-2 md:px-4 md:pb-6 md:pt-2" }
const _hoisted_3 = {
  key: 0,
  class: "pb-1 pl-2 text-gray-brand-700 text-xs font-semibold md:absolute md:bottom-0"
}
const _hoisted_4 = { class: "flex rounded-md md:mt-1 md:shadow-sm" }
const _hoisted_5 = { class: "inputfile md:bg-gray-brand-50 relative inline-flex items-center -ml-3 px-3 hover:text-gray-brand-500 text-gray-brand-700 active:text-gray-brand-700 text-sm font-medium leading-5 active:bg-gray-brand-100 hover:bg-white focus:border-blue-300 focus:outline-none focus:shadow-outline-blue transition duration-150 ease-in-out md:ml-auto md:px-4 md:py-4 md:border md:border-gray-brand-700 md:rounded-l-md" }
const _hoisted_6 = { class: "relative focus-within:z-10 flex-grow" }
const _hoisted_7 = ["placeholder"]

import { ulid } from 'ulid'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useMediaQuery } from '@/composables/useMediaQuery'
import { clearTextareaHeight, fitTextareaHeight } from '@/helpers/fitTextareaHeight'
import AttachmentIcon from '@/icon/AttachmentIcon'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'

const MOBILE_QUERY = '(max-width: 767px)'
const MOBILE_MAX_LINES = 2


export default {
  __name: 'MessageBar',
  emits: ['submit-files'],
  setup(__props, { emit: __emit }) {

const data = reactive({
  message: '',
  lastTypingTime: 0,
  pusher: null,
  privateChannel: null,
  typingTimeoutHandle: null,
  typingIndicator: ''
})

const route = useRoute()
const router = useRouter()
const store = useStore()
const emit = __emit

const input = ref(null)
const isMobile = useMediaQuery(MOBILE_QUERY)

const sizeInput = () => {
  if (!input.value) return
  if (isMobile.value) fitTextareaHeight(input.value, MOBILE_MAX_LINES)
  else clearTextareaHeight(input.value)
}

watch([() => data.message, isMobile], sizeInput, { flush: 'post' })
onMounted(sizeInput)

const conversationUserPair = computed(() => mapRelationship({ type: 'conversation_user_pair', id: route.params.id }))
const conversationId = computed(() => conversationUserPair.value.attributes.conversation_id)
const loggedInUser = computed(() => mapRelationship({ type: 'user', id: store.getters.loggedInUserId }))

watch(conversationUserPair, () => {
  if (!conversationUserPair.value) return // invalid path

  data.message = localStorage.getItem('message/' + conversationId.value) || ''
  if (route.query.message) {
    data.message = route.query.message
    router.replace({ query: null })
  }

  if (data.privateChannel && data.privateChannel.name !== 'private-c' + conversationId.value) {
    store.state.pusher.unsubscribe(data.privateChannel.name)
    data.privateChannel = null
  }

  if (!data.privateChannel) {
    data.privateChannel = store.state.pusher.subscribe('private-c' + conversationId.value)
  }

  data.privateChannel.bind(
    'client-typing',
    x => {
      if (x.conversation_id !== conversationId.value) return

      data.typingIndicator = (x.handle || 'Someone else') + ' is typing...'
      clearTimeout(data.typingTimeoutHandle)
      data.typingTimeoutHandle = setTimeout(() => {
        data.typingIndicator = ''
      }, 5000)
    },
    this
  )

  data.privateChannel.bind(
    'client-typing-x',
    x => {
      if (x.conversation_id === conversationId.value) data.typingIndicator = ''
    },
    this
  )
})

watch(
  () => data.message,
  () => {
    if (data.message) {
      localStorage.setItem('message/' + conversationId.value, data.message)
    } else {
      localStorage.removeItem('message/' + conversationId.value)
    }
  }
)

const handleKeypress = e => {
  if (e.key === 'Enter' && !e.shiftKey) {
    e.preventDefault()
    sendMessage()
  }

  if (data.privateChannel && Date.now() > data.lastTypingTime + 1500) {
    data.lastTypingTime = Date.now()
    data.privateChannel.trigger('client-typing', {
      handle: loggedInUser.value.attributes.handle,
      conversation_id: conversationId.value
    })
  }
}

const sendMessage = () => {
  if (!data.message) return

  const key = 'message_' + ulid()
  store.commit('ADD_PENDING_MESSAGE', { body: data.message, key })

  api
    .call('POST', `conversation_user_pairs/${conversationUserPair.value.id}/messages`, {
      message: {
        body: data.message,
        object_key: key
      }
    })
    .then(() => store.commit('REMOVE_PENDING_MESSAGE', key))
  data.message = ''

  data.privateChannel.trigger('client-typing-x', {
    conversation_id: conversationId.value
  })
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      (data.typingIndicator)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(data.typingIndicator), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("input", {
            id: "file",
            type: "file",
            name: "file",
            class: "inputfile__btn",
            multiple: "",
            onChange: _cache[0] || (_cache[0] = e => emit('submit-files', e.target.files))
          }, null, 32),
          _cache[4] || (_cache[4] = _createElementVNode("label", {
            for: "file",
            class: "absolute left-0 top-0 inline-block w-full h-full cursor-pointer"
          }, null, -1)),
          _createVNode(_unref(AttachmentIcon), { class: "inputfile__icon w-5 h-5 text-gray-brand-700" }),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "inputfile__text hidden ml-2 select-none md:block" }, "Upload", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("textarea", {
            ref_key: "input",
            ref: input,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((data.message) = $event)),
            rows: "1",
            class: "form-input block w-full text-sm rounded rounded-r-none appearance-none resize-none transition duration-150 ease-in-out sm:leading-5 md:border-l-0 md:border-r-0 md:rounded-none md:h-5 md:pt-3.5",
            placeholder: 'Message ' + conversationUserPair.value?.attributes.display_name,
            onKeydown: _cache[2] || (_cache[2] = $event => (handleKeypress($event)))
          }, null, 40, _hoisted_7), [
            [_vModelText, data.message]
          ])
        ]),
        _createElementVNode("button", {
          class: "relative inline-flex items-center active:text-brand-600 text-white text-sm font-medium leading-5 bg-brand-600 hover:bg-brand-700 active:bg-white border focus:border-blue-300 border-brand-700 rounded-r-md focus:outline-none focus:shadow-outline-blue select-none transition duration-150 ease-in-out px-2 md:px-12 md:py-4",
          onClick: _cache[3] || (_cache[3] = _withModifiers($event => (sendMessage()), ["prevent"]))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("span", { class: "md:ml-2" }, "Send", -1)
        ]))])
      ])
    ])
  ]))
}
}

}